import { Suspense, type PropsWithChildren } from "react";
import SuspenseFallback from "./SuspenseFallback";

type PropsType = PropsWithChildren<object>;

export default function SuspenseWrapper({ children }: PropsType) {
  return <Suspense fallback={<SuspenseFallback />}>{children}</Suspense>;
}
